import React from 'react'

const IconAccreditation = ({
  className = '',
  strokeWidth = '1'
}: {
  className?: string
  strokeWidth?: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_247_18583)">
        <path
          d="M6.79766 0.54724C7.39771 -0.182414 8.51473 -0.182413 9.11477 0.547241L10.2484 1.92571C10.5283 2.26609 10.9437 2.46615 11.3844 2.47278L13.1689 2.49961C14.1135 2.51381 14.8099 3.38713 14.6136 4.3112L14.2427 6.05695C14.1511 6.48802 14.2537 6.93756 14.5232 7.28621L15.6149 8.69813C16.1927 9.4455 15.9442 10.5345 15.0993 10.9571L13.5031 11.7556C13.109 11.9528 12.8215 12.3133 12.717 12.7414L12.2937 14.4752C12.0697 15.3929 11.0633 15.8776 10.2061 15.4805L8.58665 14.7304C8.18677 14.5452 7.72567 14.5452 7.32578 14.7304L5.70634 15.4805C4.84913 15.8776 3.84273 15.3929 3.6187 14.4752L3.19545 12.7414C3.09093 12.3133 2.80344 11.9528 2.40931 11.7556L0.813149 10.9571C-0.031734 10.5345 -0.280294 9.44549 0.297544 8.69813L1.3892 7.28621C1.65876 6.93756 1.76136 6.48802 1.66977 6.05695L1.29883 4.3112C1.10249 3.38713 1.79894 2.51381 2.74353 2.49961L4.52805 2.47278C4.96869 2.46615 5.38414 2.26609 5.66405 1.92571L6.79766 0.54724Z"
          fill="#FFA058"
          strokeWidth={strokeWidth}
        />
        <path
          d="M7.62142 4.77666C7.76506 4.46888 8.20271 4.46888 8.34636 4.77666L9.19517 6.59541C9.2349 6.68055 9.30334 6.74898 9.38847 6.78872L11.2072 7.63753C11.515 7.78117 11.515 8.21883 11.2072 8.36247L9.38847 9.21128C9.30334 9.25102 9.2349 9.31945 9.19517 9.40459L8.34635 11.2233C8.20271 11.5311 7.76506 11.5311 7.62142 11.2233L6.7726 9.40459C6.73287 9.31945 6.66444 9.25102 6.5793 9.21128L4.76055 8.36247C4.45277 8.21883 4.45277 7.78117 4.76055 7.63753L6.5793 6.78872C6.66444 6.74898 6.73287 6.68055 6.7726 6.59541L7.62142 4.77666Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_247_18583">
          <rect
            width="16"
            height="16"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconAccreditation
